module.exports = __webpack_public_path__ + "static/account-protection-hero-desktop.7b3075b2.webp";